import {styled} from '@mui/material/styles';
import React from 'react';
import type {HeaderActionAreaProps} from './types';
import {excludeComponentProps} from '../utils/excludeComponentProps';
import {headerCssClassNames} from './headerCssClassNames';

const StyledHeaderActionArea = styled('div', {
    ...excludeComponentProps('disableSpacing')
})<HeaderActionAreaProps>(({
    theme, disableSpacing
}) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'end',
    marginLeft: theme.tokens.FuelSpacing2,
    color: theme.tokens.FuelColorTextPrimary,
    fontSize: theme.tokens.FuelFontSizeBase,
    ...!disableSpacing && {
        '& > :not(:first-of-type)': {
            marginLeft: theme.tokens.FuelSpacing2
        }
    }
}));

/**
 * Wrapper for Header Component children
 */
export const HeaderActionArea = React.forwardRef<HTMLDivElement, HeaderActionAreaProps>(({
    children, disableSpacing, ...props
}, ref) => {
    return (
        <StyledHeaderActionArea
            {...props}
            className={headerCssClassNames.actionArea}
            disableSpacing={disableSpacing}
            ref={ref}
        >
            {children}
        </StyledHeaderActionArea>
    );
});

HeaderActionArea.displayName = 'HeaderActionArea';
